// token to access a stream with the information you need
import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';

export const PATH_SERVICE_URL = new InjectionToken<Observable<string>>(
  'A stream with this service path url'
);
